module.exports = __webpack_public_path__ + "img/icon-slide6.355c4e35.jpg";